import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { CreatorDistribution } from '@/types/progress';

// DEBOOK-1901: proportions for the /progress pie charts (DEBOOK-1903).
// The endpoint scopes itself by role — admin gets the whole pool, everyone
// else only their own creators — so there is nothing to pass in.
export function useCreatorDistribution() {
  return useQuery({
    queryKey: ['creator-distribution'],
    queryFn: async (): Promise<CreatorDistribution> =>
      pb.send('/api/progress/distribution', { method: 'GET' }),
    staleTime: 60_000,
  });
}
